import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import * as _ from 'lodash';
import SvgIcon from '@/components/svg-icon.vue';
import { handleClipboard } from '@/utils/clipboard';
import * as aiApi from '@/api/ai';
import { mapGetters } from 'vuex';
import CollectBadInfo from '@/components/collect-bad-info.vue';
import { md } from '@/utils/markdown';
export default {
  components: {
    SvgIcon: SvgIcon,
    CollectBadInfo: CollectBadInfo
  },
  props: {
    answer: {
      type: Object,
      default: function _default() {
        return {
          evaluate: 0
        };
      }
    },
    chatIndex: {
      type: Number,
      default: 0
    },
    answerIndex: {
      type: Number,
      default: 0
    },
    reason: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectItem: {}
    };
  },
  computed: _objectSpread({}, mapGetters('ai', ['aiChatList', 'qaId'])),
  methods: {
    feedback: function feedback(data) {
      var _this = this;
      aiApi.answerEvaluate(Object.assign({}, this.selectItem, data)).then(function (res) {
        var aiChatList = _.cloneDeep(_this.aiChatList);
        aiChatList[_this.chatIndex].answer['list'][_this.answerIndex].evaluate = _this.selectItem.evaluate;
        _this.$store.dispatch('ai/setValue', {
          key: 'aiChatList',
          value: aiChatList
        });
      });
    },
    /**
     * 使用正则表达式替换文本中的特定div标签
     * @param {string} htmlText - 包含目标div的原始HTML文本字符串
     * @returns {string} - 替换后的纯净文本字符串
     */
    replaceCopyButtonWithRegex: function replaceCopyButtonWithRegex(htmlText) {
      // 正则表达式说明：
      // <div\\s+          匹配"<div"后跟至少一个空白字符
      // [^>]*            匹配除">"外的任意字符任意次（匹配div标签内的其他属性）
      // class="markdown-copy-btn" 精确匹配class名
      // [^>]*>           匹配class定义后，直到标签结束符">"之间的内容
      // .*?              非贪婪模式，匹配标签内的任意内容（尽可能少地匹配）
      // <\\/div>         匹配结束标签"</div>"
      var pattern = /<button\s+[^>]*class="markdown-copy-btn"[^>]*>[^]*?<\/button>/gi;
      return htmlText.replace(pattern, '');
    },
    extractTableText: function extractTableText(element) {
      // 创建临时div来处理内容
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = element;

      // 处理表格 - 保留表格结构
      var tables = tempDiv.querySelectorAll('table');
      tables.forEach(function (table) {
        // 将表格转换为文本格式
        var rows = table.querySelectorAll('tr');
        var tableText = '';
        rows.forEach(function (row) {
          var cells = row.querySelectorAll('th, td');
          var rowText = Array.from(cells).map(function (cell) {
            // 提取单元格纯文本，去除HTML标签但保留内容
            return cell.textContent.trim();
          }).join('\t'); // 使用制表符分隔单元格

          tableText += rowText + '\n';
        });

        // 用文本表格替换原始表格
        var tableParent = table.parentNode;
        var textNode = document.createTextNode('\n' + tableText + '\n');
        tableParent.replaceChild(textNode, table);
      });

      // 移除其他HTML标签，但保留换行
      var text = tempDiv.textContent;

      // 清理多余的空行和空格
      text = text.replace(/\n\s*\n/g, '\n\n') // 保留段落空行
      .replace(/[ \t]+/g, ' ') // 压缩多个空格
      .trim();
      return text;
    },
    /**
     * 渲染markdown 内容
     * @param content
     * @returns {*}
     */
    renderMarkDown: function renderMarkDown(content) {
      var message = content.replaceAll('\\n', '\n');
      return md.render(message);
    },
    // 复制
    copyHandler: function copyHandler(event) {
      var content = this.renderMarkDown(this.answer.content);
      handleClipboard(event, this.extractTableText(this.replaceCopyButtonWithRegex(content)));
    },
    // 点赞
    evaluateHandler: function evaluateHandler(answer, evaluate) {
      var _this2 = this;
      var aLogId = this.answer.aLogId;
      var chatIndex = this.findChatIndex();
      var answerIndex = this.findAnswerIndex(chatIndex, aLogId);
      // 请求接口
      aiApi.answerEvaluate({
        answerId: aLogId,
        evaluate: evaluate
      }).then(function (res) {
        var aiChatList = _.cloneDeep(_this2.aiChatList);
        aiChatList[chatIndex].answer['list'][answerIndex].evaluate = evaluate;
        _this2.$store.dispatch('ai/setValue', {
          key: 'aiChatList',
          value: aiChatList
        });
      });
    },
    /**
     * 收集点踩信息
     */
    collectInfo: function collectInfo(answer, evaluate) {
      var _this3 = this;
      if (this.reason) {
        this.selectItem = {
          answerId: answer.aLogId,
          evaluate: evaluate
        };
        this.$refs['collectRef'].handleOpen('');
      } else {
        var aLogId = this.answer.aLogId;
        var chatIndex = this.findChatIndex();
        var answerIndex = this.findAnswerIndex(chatIndex, aLogId);
        // 请求接口
        aiApi.answerEvaluate({
          answerId: aLogId,
          evaluate: evaluate
        }).then(function (res) {
          var aiChatList = _.cloneDeep(_this3.aiChatList);
          aiChatList[chatIndex].answer['list'][answerIndex].evaluate = evaluate;
          _this3.$store.dispatch('ai/setValue', {
            key: 'aiChatList',
            value: aiChatList
          });
        });
      }
    },
    reloadHandler: function reloadHandler() {
      var aLogId = this.answer.aLogId;
      var chatIndex = this.findChatIndex();
      var answerIndex = this.findAnswerIndex(chatIndex, aLogId);
      this.$store.dispatch('ai/setValue', {
        key: 'reloadHandler',
        value: {
          isReload: true,
          data: {
            chatIndex: chatIndex,
            answerIndex: answerIndex
          }
        }
      });
    },
    /**
     * 获取答案所在的下标
     * @param chatIndex
     * @param aLogId
     * @returns {number}
     */
    findAnswerIndex: function findAnswerIndex(chatIndex, aLogId) {
      return this.aiChatList[chatIndex].answer.list.findIndex(function (answer) {
        return answer.aLogId === aLogId;
      });
    },
    /**
     * 所在窗口的下标
     * @returns {*}
     */
    findChatIndex: function findChatIndex() {
      var _this4 = this;
      var chatIndex = 0;
      this.aiChatList.forEach(function (chat, index) {
        var answer = chat.answer;
        // eslint-disable-next-line no-return-assign
        var _index = answer.list.findIndex(function (item) {
          return item.aLogId === _this4.answer.aLogId;
        });
        if (_index !== -1) {
          chatIndex = index;
        }
      });
      return chatIndex;
    }
  }
};